// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JMRRfMqqsYuKtQydi0u6{flex-direction:column;flex-grow:1;gap:24px;padding:12px 20px 20px;display:flex}.CgA2szU2TYUdMNvhEcG6{align-items:center;gap:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `JMRRfMqqsYuKtQydi0u6`,
	"row": `CgA2szU2TYUdMNvhEcG6`
};
export default ___CSS_LOADER_EXPORT___;
